export const THEME_MODES = ['light', 'dark', 'system'] as const;

export type ThemeMode = (typeof THEME_MODES)[number];

export type ResolvedTheme = 'light' | 'dark';

export const DEFAULT_THEME_MODE: ThemeMode = 'light';

export const THEME_STORAGE_KEY = 'mydeals_theme';

export const DARK_CLASS = 'app-dark';

export function isThemeMode(value: string | null | undefined): value is ThemeMode {
  return value != null && (THEME_MODES as readonly string[]).includes(value);
}
